import { palette, heading, paragraph, fonts, chart, assets, shadows, gradients, } from "./palette";
import type { Theme, Strata, ThemePalette, } from "@bracket/ui/types";



export const lightOriginal: Theme = {
	name: "light-original",
	assets,
	fonts,
	typeface: {
		p: paragraph,
		...heading,
	},
	chart,
	shadows,
	gradients,
	...palette,
	// @ts-expect-error - TODO: fix this
	strata: function ( level?: Strata ) {
		const key = level ? level === "default" ? "surface_container" : `surface_container_${level}` : "surface_container";
		return key in this ? this[key as keyof ThemePalette] : this.surface_container;
	}
};
